import { a as angleDoubleInlineStart, b as angleDoubleInlineEnd, c as angleInlineStart, d as angleInlineEnd, e as caretInlineStart, f as caretInlineEnd } from './localIcons-9_jhfe7X.js';

const angleDoubleRight = {
  ...angleDoubleInlineEnd,
  iconName: 'angle-double-right'
};
const angleDoubleLeft = {
  ...angleDoubleInlineStart,
  iconName: 'angle-double-left'
};
const angleLeft = {
  ...angleInlineStart,
  iconName: 'angle-left'
};
const angleRight = {
  ...angleInlineEnd,
  iconName: 'angle-right'
};
const caretLeft = {
  ...caretInlineStart,
  iconName: 'caret-left'
};
const caretRight = {
  ...caretInlineEnd,
  iconName: 'caret-right'
};

export { angleDoubleRight as a, angleDoubleLeft as b, angleLeft as c, angleRight as d, caretLeft as e, caretRight as f };
//# sourceMappingURL=classicIcons-CHpXglL2.js.map
